module.exports = __webpack_public_path__ + "media/images/story/top/point_image_5-6932b1edf991463e165d380ac21a46f5.jpg";